var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 55.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f7f8f9;}.cls-4{fill:#fff;}.cls-5{fill:#b9bbbd;}.cls-6{fill:#121111;}.cls-7{fill:#1ebfe8;}.cls-8{clip-path:url(#clippath-1);}.cls-9{clip-path:url(#clippath-4);}.cls-10{clip-path:url(#clippath-3);}.cls-11{clip-path:url(#clippath-2);}.cls-12{clip-path:url(#clippath-7);}.cls-13{clip-path:url(#clippath-8);}.cls-14{clip-path:url(#clippath-6);}.cls-15{clip-path:url(#clippath-5);}.cls-16{clip-path:url(#clippath-9);}.cls-17{clip-path:url(#clippath-20);}.cls-18{clip-path:url(#clippath-21);}.cls-19{clip-path:url(#clippath-24);}.cls-20{clip-path:url(#clippath-23);}.cls-21{clip-path:url(#clippath-22);}.cls-22{clip-path:url(#clippath-25);}.cls-23{clip-path:url(#clippath-27);}.cls-24{clip-path:url(#clippath-28);}.cls-25{clip-path:url(#clippath-26);}.cls-26{clip-path:url(#clippath-29);}.cls-27{clip-path:url(#clippath-14);}.cls-28{clip-path:url(#clippath-13);}.cls-29{clip-path:url(#clippath-12);}.cls-30{clip-path:url(#clippath-10);}.cls-31{clip-path:url(#clippath-15);}.cls-32{clip-path:url(#clippath-17);}.cls-33{clip-path:url(#clippath-16);}.cls-34{clip-path:url(#clippath-19);}.cls-35{clip-path:url(#clippath-11);}.cls-36{clip-path:url(#clippath-18);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.3,
    y: 9.38,
    width: 141.39,
    height: 36.31
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.85,45.68h3.27c19.81,0,39.63,0,59.44-.02,4.31,0,8.09-3.78,8.12-8.08.03-6.68.01-13.37,0-20.05,0-1.74-.59-3.3-1.62-4.68-1.82-2.44-4.29-3.47-7.32-3.47-41.17.02-82.33.01-123.5.02-.71,0-1.41,0-2.12.14-3.8.7-6.79,4.16-6.81,8-.03,6.75-.02,13.51,0,20.26.01,2.05.82,3.84,2.22,5.31,1.75,1.83,3.92,2.59,6.45,2.59,20.62-.02,41.24-.01,61.86-.01"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.88,45.37h61.79c.55,0,1.08-.03,1.63-.11,4.06-.57,7.09-4.02,7.09-8.14,0-6.38,0-12.75,0-19.13,0-.6-.08-1.18-.21-1.76-.89-3.93-4.16-6.53-8.19-6.53H13.49c-.62,0-1.22.03-1.84.11-3.9.52-7.03,4.03-7.03,7.98-.02,6.59-.01,13.18,0,19.76,0,.98.21,1.93.61,2.82,1.49,3.33,4.11,4.98,7.72,4.98,20.64.01,41.29,0,61.93,0m-.03.31c-20.62,0-41.24-.01-61.86.01-2.53,0-4.71-.76-6.45-2.59-1.4-1.47-2.21-3.26-2.22-5.31-.03-6.75-.03-13.51,0-20.26.02-3.85,3.01-7.3,6.81-8,.71-.13,1.41-.14,2.12-.14,41.17,0,82.33,0,123.5-.02,3.03,0,5.5,1.04,7.32,3.47,1.03,1.38,1.62,2.94,1.62,4.68,0,6.68.02,13.37,0,20.05-.02,4.3-3.8,8.08-8.12,8.08-19.82.02-39.63.01-59.44.02h-3.27"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m44.88,19.98h.01c0-.47,0-.94,0-1.41,0-.28,0-.5-.4-.5-.37,0-.43.18-.42.48.01.78,0,1.56,0,2.33,0,.92-.11,1.02-1,1.01-.15,0-.35-.12-.37.16-.01.21-.04.39.25.5.9.34,1.83-.19,1.92-1.16.04-.47,0-.94,0-1.41m11.63.65c0,.5.02,1,0,1.49-.02.33.13.39.42.39.31,0,.42-.1.41-.41-.02-.74,0-1.47,0-2.2,0-1.03,0-1.04,1.01-1.14.23-.02.36-.06.36-.31,0-.27-.08-.38-.37-.38-.93.01-1.85,0-2.77,0-.24,0-.42.02-.43.33,0,.29.14.34.39.36.99.08.99.09.99,1.08v.78m-4.21,1.98c.28,0,.37,0,.46,0,.84-.06,1.39-.49,1.49-1.16.1-.7-.2-1.11-1.07-1.45-.26-.1-.53-.2-.78-.32-.24-.11-.36-.3-.31-.57.05-.25.24-.33.45-.39.33-.09.65,0,.98.04.15.02.39.21.45-.11.05-.25,0-.47-.31-.53-.47-.1-.93-.17-1.4-.06-.53.12-.9.43-1,.98-.11.58.11,1.03.64,1.3.36.18.74.31,1.1.48.25.11.46.28.42.59-.05.33-.3.47-.6.51-.38.05-.75,0-1.13-.08-.15-.04-.34-.12-.4.11-.06.21-.04.45.22.52.32.09.64.14.79.17m15.13,0c.31,0,.43.01.54,0,.81-.07,1.32-.48,1.43-1.14.12-.7-.18-1.12-1.03-1.46-.24-.1-.49-.18-.72-.29-.25-.11-.44-.29-.39-.6.06-.32.31-.42.57-.43.28-.01.56.05.84.06.17,0,.43.25.49-.15.04-.29-.09-.45-.36-.5-.44-.09-.88-.15-1.33-.05-.53.12-.92.39-1.02.95-.11.6.08,1.08.65,1.35.34.16.7.29,1.04.44.28.12.51.3.44.64-.06.33-.33.44-.63.48-.36.04-.7,0-1.06-.07-.16-.03-.39-.19-.43.14-.04.22-.01.43.26.5.3.06.6.12.71.14m-3.93-1.17c.67-.19,1.02.09,1.12.76.06.41.42.36.68.29.37-.09.1-.34.05-.5-.39-1.14-.8-2.26-1.21-3.4-.11-.29-.19-.55-.61-.54-.4,0-.52.2-.63.51-.4,1.14-.83,2.26-1.22,3.4-.05.15-.36.41-.02.51.24.08.64.18.72-.29.11-.66.46-.94,1.13-.75m-13.57-1.6c0-.51-.01-.94,0-1.37,0-.31-.13-.4-.43-.4-.33-.01-.39.14-.39.42.01.76.01,1.51,0,2.27-.01.82-.31,1.17-1,1.16-.65-.01-.95-.34-.97-1.13-.02-.78-.01-1.56,0-2.34,0-.26-.06-.39-.36-.38-.28,0-.45.05-.44.38.02.95-.02,1.9.06,2.84.07.86.69,1.3,1.64,1.33,1.01.02,1.61-.39,1.81-1.24.12-.54.04-1.09.07-1.54m24.4,2.63c-.57-.64-1.05-1.24-1.59-1.78-.37-.38-.42-.64-.01-1.02.48-.45.89-.97,1.41-1.56-1.48-.19-1.62,1.25-2.58,1.68,0-.47-.01-.91,0-1.34.01-.34-.2-.36-.46-.37-.29-.01-.36.12-.36.38,0,1.23.01,2.46,0,3.68,0,.34.14.38.42.39.3,0,.42-.1.41-.41-.02-.48,0-.96,0-1.47,1.03.52,1.2,2.11,2.77,1.83m37.88,7.33c0,1.75-.02,3.5,0,5.25.01,1.19.78,1.76,1.93,1.52.29-.06.41-.18.4-.47,0-.26-.12-.42-.39-.38-.94.14-.96-.44-.95-1.12.02-3.22.02-6.44,0-9.65,0-.37.28-.98-.52-.97-.76,0-.46.59-.47.94-.03,1.63-.01,3.26-.01,4.9m-37.8,5.89c1.35-1.71,2.58-3.27,3.81-4.82.45-.58.93-1.14,1.36-1.73.38-.52.24-1.11-.26-1.12-1.8-.02-3.6,0-5.4-.01-.28,0-.45.08-.45.4,0,.31.09.5.44.48.19-.01.38,0,.57,0h4.15c-.82,1.04-1.54,1.97-2.27,2.89-.95,1.21-1.89,2.43-2.86,3.63-.24.3-.27.62-.17.93.12.37.48.21.74.22,1.68.01,3.36,0,5.05,0,.32,0,.7.1.7-.44,0-.55-.4-.43-.71-.43-1.51,0-3.01,0-4.7,0m52.76-4.39c-.14-.18-.23-.29-.31-.4-.61-.87-1.23-1.75-1.83-2.62-.28-.4-.73-.37-1.01-.19-.33.21.05.49.19.7.67.97,1.34,1.95,2.06,2.9.25.33.22.55-.01.86-.8,1.08-1.58,2.19-2.36,3.29-.13.18-.4.39-.2.62.2.23.53.16.79.05.13-.06.23-.24.32-.37.62-.9,1.27-1.77,1.84-2.7.36-.58.53-.52.87,0,.63.98,1.32,1.91,1.98,2.86.28.4.71.37,1.01.19.36-.22-.02-.49-.16-.69-.75-1.09-1.5-2.19-2.29-3.25-.26-.36-.3-.61-.01-.98.71-.92,1.37-1.88,2.03-2.83.13-.19.48-.42.18-.65-.23-.17-.59-.17-.86.07-.12.11-.2.27-.3.4-.62.89-1.25,1.78-1.92,2.75m-35.61-2.39c-.02-.14-.05-.23-.05-.31.01-.39-.11-.63-.57-.6-.5.04-.39.39-.39.68,0,2.42,0,4.83,0,7.25,0,.36,0,.64.51.65.5,0,.51-.26.51-.63,0-1.54,0-3.08,0-4.62,0-1.82.11-1.96,1.88-2.45.23-.06.46-.11.69-.14,1.8-.26,2.47.32,2.47,2.12,0,1.73,0,3.46,0,5.19,0,.34.08.53.48.53.39,0,.56-.13.55-.53-.01-1.96-.01-3.93-.01-5.89,0-.02,0-.05,0-.07-.13-1.53-.96-2.3-2.5-2.32-1.05-.01-2,.31-2.91.81-.2.11-.4.22-.64.36m-2.81,3.54c-.04-.5-.04-.93-.11-1.35-.3-2.05-1.67-3.29-3.67-3.35-2.15-.07-3.56,1.03-4,3.12-.2.94-.19,1.88,0,2.82.43,2,1.74,3.1,3.73,3.12,2.05.03,3.39-1.01,3.86-3.03.11-.46.13-.93.19-1.33m-40.75,3.18c.04.27.06.4.07.55.03.36.27.39.56.38.33,0,.38-.2.38-.47,0-2.06.02-4.12-.02-6.18-.02-.83-.4-1.53-1.22-1.85-1.52-.59-3.03-.31-4.51.22-.3.11-.29.36-.24.59.06.31.3.24.5.17.66-.2,1.34-.31,2.02-.38,1.77-.16,2.46.46,2.47,2.23,0,.12-.01.24,0,.36.07.54-.05.75-.67.57-.94-.27-1.91-.34-2.88-.08-1.47.39-2.23,1.56-1.98,3.06.21,1.27,1.25,2.01,2.71,1.95,1.03-.04,1.91-.47,2.82-1.11m22.73-.01c.02.24.04.38.05.52.01.34.22.42.52.42.36,0,.43-.19.43-.5,0-2.01.01-4.03-.02-6.04-.02-.82-.33-1.57-1.13-1.92-1.56-.68-3.1-.37-4.63.17-.3.11-.28.37-.23.59.07.31.31.2.51.16.51-.11,1.01-.24,1.53-.31,2.38-.3,2.96.24,2.97,2.59,0,.51-.08.66-.62.51-.99-.28-2.01-.36-3.02-.08-1.42.39-2.13,1.52-1.9,3.04.18,1.24,1.2,1.99,2.63,1.96,1.06-.03,1.96-.46,2.9-1.12m66.25.04c.04.15.07.22.07.29.02.36.08.64.56.61.5-.04.4-.38.4-.67,0-1.89.01-3.79,0-5.68,0-.87-.25-1.69-1.1-2.08-1.57-.73-3.14-.39-4.69.15-.31.11-.24.39-.19.61.07.33.33.18.52.13.59-.17,1.2-.27,1.81-.34,1.94-.23,2.64.38,2.64,2.31,0,.12-.01.24,0,.35.06.48-.08.63-.59.49-.96-.26-1.95-.35-2.95-.1-1.45.37-2.21,1.5-2.01,2.97.18,1.32,1.21,2.09,2.71,2.04,1.03-.04,1.91-.47,2.81-1.08m-28.01-.01c.03.21.06.33.06.44,0,.37.19.48.54.47.36-.01.42-.22.42-.51,0-1.99.01-3.98-.02-5.96-.01-.82-.29-1.58-1.08-1.95-1.57-.73-3.14-.4-4.69.15-.3.11-.25.38-.2.61.08.32.33.19.52.13.59-.18,1.19-.28,1.81-.35,1.94-.23,2.64.38,2.64,2.31,0,.12-.01.24,0,.36.06.48-.09.62-.59.49-.94-.26-1.91-.35-2.88-.11-1.53.37-2.31,1.53-2.06,3.06.22,1.33,1.29,2.06,2.84,1.96.97-.07,1.81-.49,2.69-1.08m6.23-3.4h.06c0,.31-.03.62,0,.93.14,1.3.55,2.49,1.79,3.12,1.56.8,3.16.64,4.74,0,.34-.14.41-.4.31-.69-.12-.36-.38-.14-.59-.07-.94.31-1.89.41-2.87.3-1.2-.13-1.98-.85-2.26-2.03-.18-.76-.15-.78.59-.64,1.15.21,2.3.34,3.45,0,1.24-.36,1.89-1.25,1.9-2.59.01-1.32-.64-2.26-1.84-2.65-2.46-.8-4.65.46-5.15,2.98-.09.44-.1.89-.14,1.34m-62.97-3.42c-.07-.44-.02-.94-.65-.83-.59.11-.31.57-.32.85-.02,2.35-.01,4.69-.01,7.04,0,.33-.07.67.46.67.56.01.53-.32.53-.69,0-1.64,0-3.27,0-4.91,0-1.46.08-1.58,1.46-2.06.22-.07.45-.13.69-.17,1.79-.3,2.43.23,2.44,2.03.01,1.73.01,3.46,0,5.19,0,.4.1.61.55.61.47,0,.47-.27.47-.61,0-1.69,0-3.37,0-5.05,0-1.42.06-1.51,1.43-1.99.11-.04.23-.07.34-.1,1.99-.56,2.84.07,2.84,2.12,0,1.68,0,3.36,0,5.05,0,.36.06.58.5.57.36-.01.51-.13.51-.5-.01-2.02.04-4.03-.03-6.05-.05-1.56-1-2.33-2.57-2.27-1.23.05-2.28.56-3.27,1.25-1.09-1.64-2.48-1.69-5.37-.17m-31.4,12.29c.05.14.18.13.29.15,1.3.21,2.6.16,3.89-.07,7.42-1.36,12.29-7.79,11.62-15.31-.72-8.02-8.35-13.87-16.23-12.45-6.13,1.11-10.72,6.07-11.47,12.41-.7,5.94,2.72,11.9,8.27,14.35,1.1.49,2.23.94,3.47.92.05,0,.1,0,.15,0m54.07,4.25c-20.64,0-41.29,0-61.93,0-3.62,0-6.23-1.65-7.72-4.98-.4-.89-.61-1.84-.61-2.82-.01-6.59-.02-13.18,0-19.76,0-3.96,3.14-7.46,7.03-7.98.61-.08,1.22-.11,1.84-.11,41.17,0,82.33,0,123.5,0,4.03,0,7.3,2.6,8.19,6.53.13.57.21,1.16.21,1.76-.01,6.38,0,12.75,0,19.13,0,4.12-3.03,7.57-7.09,8.14-.55.08-1.08.11-1.63.11h-61.79"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.81,41.12s-.1,0-.15,0c-.02-.8-.05-1.6-.05-2.41,0-1.27-.58-2.13-1.74-2.67-4.06-1.91-6.19-6.05-5.44-10.47.78-4.58,5.12-8.11,9.66-7.87,5.9.31,10.15,5.64,9.02,11.48-1.22,6.34-5.27,10.11-11.3,11.95"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m20.81,41.12c6.04-1.84,10.08-5.61,11.3-11.95,1.12-5.84-3.12-11.17-9.02-11.48-4.55-.24-8.88,3.29-9.66,7.87-.75,4.42,1.38,8.56,5.44,10.47,1.16.55,1.74,1.4,1.74,2.67,0,.8.04,1.6.05,2.41-1.24.01-2.37-.44-3.47-.93-5.55-2.44-8.97-8.41-8.27-14.35.75-6.34,5.33-11.3,11.47-12.41,7.88-1.43,15.51,4.43,16.23,12.45.68,7.52-4.19,13.95-11.62,15.31-1.29.24-2.59.28-3.89.08-.12-.02-.24-.02-.29-.15"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m52.22,28.83c2.89-1.53,4.28-1.47,5.37.17.99-.68,2.04-1.2,3.27-1.25,1.58-.06,2.52.72,2.57,2.28.07,2.01.02,4.03.03,6.04,0,.37-.14.49-.51.5-.44.01-.5-.21-.5-.57.01-1.68.01-3.36,0-5.05,0-2.06-.85-2.68-2.84-2.12-.11.03-.23.06-.34.1-1.37.48-1.43.57-1.43,1.99,0,1.68,0,3.37,0,5.05,0,.33,0,.6-.46.61-.46,0-.56-.2-.56-.61.01-1.73.01-3.46,0-5.19-.01-1.8-.65-2.33-2.44-2.03-.23.04-.46.1-.69.17-1.38.47-1.46.59-1.46,2.06,0,1.64,0,3.27,0,4.91,0,.38.03.7-.53.69-.54,0-.46-.34-.46-.67,0-2.35-.01-4.69.01-7.04,0-.29-.28-.75.32-.86.63-.11.58.39.65.83"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m118.5,32.51c.52-.02,1.04-.05,1.54-.2.87-.28,1.32-.9,1.3-1.8-.02-.9-.5-1.51-1.37-1.75-2.13-.57-3.89.91-3.75,3.16.02.29.15.35.39.38.63.06,1.26.14,1.9.21m-3.32-.26c.04-.45.05-.9.14-1.34.51-2.52,2.7-3.78,5.16-2.98,1.2.39,1.85,1.33,1.84,2.65-.01,1.34-.66,2.23-1.9,2.59-1.14.33-2.29.21-3.45-.01-.75-.14-.76-.11-.59.65.27,1.18,1.05,1.89,2.26,2.03.98.11,1.94,0,2.88-.3.21-.07.46-.29.58.07.1.29.03.55-.31.69-1.58.63-3.18.78-4.74,0-1.25-.63-1.65-1.83-1.79-3.12-.04-.3,0-.62,0-.92-.02,0-.04,0-.06,0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m108.94,33.81c-.11-.35.29-.93-.23-1.09-1.11-.33-2.27-.49-3.39,0-.72.32-1.04,1.1-.86,1.97.14.68.64,1.09,1.43,1.14.72.05,1.39-.19,2.05-.45.72-.28,1.29-.63,1-1.57m.01,1.84c-.88.59-1.71,1.02-2.69,1.08-1.54.11-2.62-.63-2.84-1.96-.25-1.52.53-2.69,2.06-3.06.97-.24,1.94-.14,2.88.12.5.13.65,0,.59-.49-.01-.12,0-.24,0-.35,0-1.92-.7-2.53-2.64-2.31-.61.07-1.21.17-1.81.34-.19.06-.44.19-.52-.13-.05-.22-.1-.5.2-.61,1.54-.55,3.11-.88,4.69-.15.8.37,1.07,1.13,1.08,1.95.03,1.99.02,3.98.02,5.96,0,.29-.05.5-.42.51-.35,0-.54-.1-.54-.48,0-.11-.03-.23-.06-.44"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m136.99,33.97c0-.38,0-.64,0-.89.01-.22-.05-.34-.29-.4-1.07-.25-2.14-.4-3.2-.03-.82.29-1.2,1.09-1.02,2.02.14.73.69,1.15,1.55,1.17.7.01,1.34-.23,1.98-.48.71-.27,1.21-.64.97-1.39m-.03,1.69c-.9.61-1.78,1.04-2.81,1.08-1.49.05-2.53-.72-2.71-2.04-.2-1.48.56-2.6,2.01-2.97.99-.25,1.98-.16,2.95.1.51.14.65-.01.59-.49-.01-.12,0-.24,0-.36,0-1.92-.7-2.53-2.64-2.3-.61.07-1.21.18-1.81.34-.19.06-.44.2-.52-.13-.05-.21-.12-.5.19-.61,1.55-.55,3.12-.88,4.69-.15.85.39,1.09,1.21,1.1,2.08.01,1.89,0,3.79,0,5.68,0,.29.1.63-.4.67-.49.04-.55-.25-.56-.61,0-.07-.03-.14-.07-.29"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m70.72,33.84c-.2-.34.31-.94-.22-1.11-1.13-.35-2.32-.51-3.46,0-.69.31-1,1.1-.84,1.93.15.72.64,1.13,1.47,1.17.75.04,1.43-.23,2.11-.5.7-.27,1.15-.64.93-1.49m0,1.78c-.94.66-1.84,1.09-2.9,1.12-1.43.04-2.45-.71-2.63-1.95-.23-1.52.48-2.65,1.9-3.04,1.01-.27,2.03-.19,3.02.08.54.15.62,0,.62-.5,0-2.36-.59-2.89-2.97-2.59-.51.06-1.02.2-1.53.31-.21.04-.44.15-.51-.16-.05-.23-.07-.49.23-.59,1.52-.55,3.07-.85,4.63-.17.8.35,1.11,1.1,1.13,1.92.04,2.01.01,4.03.02,6.04,0,.31-.07.49-.43.5-.31,0-.51-.07-.52-.42,0-.14-.02-.28-.05-.52"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m47.99,33.7c-.16-.28.31-.83-.25-.99-1.09-.32-2.23-.47-3.33-.02-.75.3-1.11,1.1-.94,1.93.16.77.66,1.18,1.52,1.21.68.03,1.31-.18,1.92-.43,1.08-.45,1.08-.46,1.08-1.7m0,1.94c-.9.63-1.79,1.06-2.82,1.11-1.46.06-2.5-.69-2.71-1.95-.25-1.51.51-2.67,1.98-3.06.96-.25,1.94-.18,2.88.08.63.18.74-.03.67-.57-.01-.12,0-.24,0-.36-.01-1.76-.7-2.39-2.47-2.22-.68.06-1.36.17-2.02.38-.21.06-.44.14-.5-.18-.05-.23-.06-.48.24-.59,1.48-.52,2.98-.81,4.51-.22.81.32,1.2,1.02,1.22,1.85.04,2.06.02,4.12.02,6.19,0,.27-.05.46-.38.47-.29,0-.52-.02-.55-.38-.01-.14-.04-.28-.07-.55"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m87.7,32.29c-.01-.65-.09-1.28-.31-1.89-.41-1.16-1.32-1.76-2.64-1.76-1.31,0-2.25.62-2.63,1.77-.32.96-.36,1.94-.19,2.94.28,1.67,1.15,2.49,2.72,2.53,1.66.04,2.57-.71,2.9-2.39.08-.39.1-.8.14-1.2m1.03.16c-.06.4-.08.87-.19,1.33-.48,2.02-1.81,3.06-3.86,3.03-1.98-.02-3.3-1.13-3.73-3.12-.2-.94-.2-1.88,0-2.82.44-2.1,1.85-3.19,4-3.12,2,.06,3.37,1.3,3.67,3.35.06.42.07.85.11,1.35"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m91.54,28.91c.24-.13.44-.25.64-.36.91-.5,1.86-.82,2.91-.81,1.54.02,2.37.79,2.5,2.32,0,.02,0,.05,0,.07,0,1.96,0,3.93.01,5.89,0,.4-.16.54-.55.53-.39,0-.48-.19-.48-.53.01-1.73,0-3.46,0-5.19,0-1.81-.68-2.38-2.47-2.12-.23.03-.47.08-.69.14-1.77.5-1.88.64-1.88,2.45,0,1.54,0,3.08,0,4.62,0,.37-.01.64-.51.63-.5,0-.51-.29-.51-.65,0-2.42,0-4.83,0-7.25,0-.29-.1-.64.39-.68.46-.03.58.2.57.6,0,.08.03.17.05.31"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m127.16,31.29c.68-.96,1.3-1.85,1.92-2.74.1-.14.17-.29.3-.4.26-.24.63-.24.86-.07.31.23-.05.46-.18.65-.66.95-1.33,1.91-2.03,2.83-.29.37-.25.62.01.98.79,1.07,1.54,2.16,2.29,3.25.14.2.52.48.16.7-.29.18-.73.21-1.01-.2-.66-.95-1.35-1.89-1.98-2.86-.34-.53-.51-.59-.87,0-.57.93-1.22,1.81-1.84,2.7-.09.13-.18.31-.32.37-.26.11-.59.18-.79-.05s.07-.43.2-.62c.78-1.11,1.56-2.21,2.36-3.29.23-.31.26-.52.01-.86-.71-.94-1.39-1.92-2.06-2.9-.14-.21-.52-.48-.19-.7.28-.18.73-.21,1.01.19.61.88,1.22,1.75,1.83,2.62.08.12.17.22.31.4"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m74.4,35.69c1.69,0,3.2,0,4.71,0,.31,0,.7-.12.71.43,0,.53-.38.44-.7.44-1.68,0-3.36.01-5.05,0-.26,0-.63.15-.74-.22-.1-.31-.06-.64.17-.93.96-1.2,1.91-2.42,2.86-3.63.72-.92,1.45-1.85,2.27-2.89h-4.15c-.19,0-.38-.01-.57,0-.35.02-.45-.17-.44-.48,0-.32.18-.4.45-.4,1.8,0,3.6-.01,5.4,0,.5,0,.64.59.26,1.12-.43.59-.9,1.16-1.36,1.73-1.23,1.56-2.46,3.11-3.81,4.82"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m112.2,29.8c0-1.63-.02-3.27.01-4.9,0-.35-.29-.93.48-.94.8,0,.51.6.51.97.02,3.22.02,6.43,0,9.65,0,.69.02,1.26.95,1.12.26-.04.38.12.39.38,0,.29-.12.41-.4.47-1.16.24-1.92-.33-1.94-1.52-.02-1.75,0-3.5,0-5.25"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m74.32,22.47c-1.57.28-1.74-1.31-2.77-1.83,0,.51-.02,1,0,1.47.01.31-.1.41-.41.41-.28,0-.42-.05-.42-.39.02-1.23.01-2.46,0-3.68,0-.26.07-.39.36-.38.26,0,.47.02.46.37-.01.44,0,.87,0,1.34.96-.43,1.11-1.87,2.58-1.68-.52.58-.94,1.11-1.41,1.56-.4.38-.36.65.01,1.02.54.54,1.03,1.14,1.59,1.78"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m49.93,19.84c-.03.45.06,1-.07,1.54-.19.85-.8,1.27-1.81,1.24-.95-.02-1.57-.48-1.64-1.33-.08-.94-.04-1.89-.06-2.84,0-.33.16-.38.44-.38.3,0,.36.13.36.38,0,.78-.01,1.56,0,2.34.02.78.32,1.12.97,1.13.69.01.99-.33,1-1.16.01-.76.01-1.51,0-2.27,0-.29.06-.44.39-.43.3.01.44.1.43.41-.01.43,0,.85,0,1.37"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m63.5,18.88c-.21.6-.34,1.03-.51,1.43-.19.45.01.49.4.51.58.04.86-.06.55-.7-.17-.33-.25-.71-.43-1.24m0,2.57c-.67-.19-1.02.09-1.13.75-.07.48-.47.37-.72.29-.34-.11-.03-.37.02-.51.39-1.14.82-2.26,1.22-3.39.11-.32.23-.51.63-.52.43,0,.51.25.61.54.4,1.13.82,2.26,1.21,3.4.05.15.33.41-.05.5-.26.06-.61.12-.68-.29-.1-.67-.45-.95-1.12-.76"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m67.43,22.61c-.12-.02-.42-.08-.71-.15-.28-.06-.3-.27-.26-.5.05-.32.27-.17.43-.14.35.07.7.11,1.06.07.3-.03.57-.15.63-.48.07-.34-.16-.52-.44-.64-.35-.15-.7-.28-1.04-.45-.57-.27-.76-.75-.65-1.35.1-.56.49-.83,1.02-.95.45-.1.89-.04,1.33.05.27.06.4.21.36.5-.06.39-.32.15-.49.15-.28,0-.56-.07-.84-.06-.26.01-.52.11-.57.43-.05.31.14.48.39.6.24.11.48.19.72.29.86.34,1.15.76,1.04,1.46-.11.66-.62,1.07-1.43,1.14-.12,0-.24,0-.55,0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m52.3,22.61c-.15-.03-.48-.08-.79-.17-.26-.07-.28-.31-.22-.52.06-.24.25-.14.4-.11.37.09.75.13,1.13.08.3-.04.55-.17.6-.51.05-.31-.17-.48-.42-.59-.36-.17-.75-.3-1.1-.48-.52-.27-.74-.72-.64-1.3.1-.55.46-.86,1-.98.47-.11.94-.05,1.4.05.31.07.36.28.31.53-.06.33-.3.13-.45.11-.33-.04-.65-.13-.98-.04-.21.06-.4.13-.45.39-.05.27.07.46.31.57.26.12.52.22.78.32.86.34,1.16.75,1.07,1.45-.1.68-.64,1.11-1.49,1.16-.09,0-.19,0-.46,0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m56.51,20.63v-.78c0-.99,0-1-.99-1.08-.25-.02-.4-.07-.39-.36,0-.3.19-.33.43-.33.92,0,1.85.01,2.77,0,.29,0,.37.12.37.38,0,.26-.14.29-.36.32-1.01.1-1.01.11-1.01,1.14,0,.74-.01,1.47,0,2.2,0,.31-.1.42-.41.41-.29,0-.43-.06-.42-.39.02-.5,0-1,0-1.49"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m44.88,19.98c0,.47.03.95,0,1.41-.08.97-1.01,1.5-1.91,1.16-.29-.11-.26-.3-.25-.5.02-.27.22-.16.37-.16.9,0,1-.09,1-1.01,0-.78.01-1.56,0-2.34,0-.3.05-.48.42-.48.39,0,.4.22.4.5-.01.47,0,.94,0,1.41h-.01Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m118.5,32.51c-.63-.07-1.26-.15-1.9-.21-.24-.02-.37-.08-.39-.38-.14-2.24,1.62-3.73,3.75-3.16.87.23,1.35.84,1.37,1.75.02.9-.42,1.52-1.29,1.8-.5.16-1.02.19-1.54.2"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m108.94,33.81c.29.94-.28,1.29-1,1.57-.66.26-1.33.5-2.05.45-.79-.05-1.29-.46-1.43-1.14-.18-.87.14-1.65.86-1.97,1.12-.49,2.28-.34,3.39,0,.52.16.13.74.23,1.09"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m137,33.97c.24.75-.26,1.12-.97,1.39-.64.24-1.28.49-1.98.47-.86-.02-1.41-.44-1.56-1.16-.18-.93.2-1.73,1.02-2.02,1.06-.37,2.14-.22,3.21.03.23.06.3.18.29.4-.01.26,0,.52,0,.89"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.71,33.84c.23.85-.23,1.22-.92,1.49-.69.27-1.37.53-2.12.5-.83-.04-1.33-.45-1.47-1.17-.17-.83.15-1.62.84-1.93,1.14-.51,2.33-.36,3.46,0,.53.17.02.77.21,1.11"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m47.99,33.7c0,1.24,0,1.25-1.08,1.7-.61.26-1.24.46-1.92.43-.86-.04-1.36-.44-1.52-1.21-.17-.83.19-1.63.94-1.93,1.11-.45,2.24-.3,3.33.02.56.16.08.71.25.99"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m87.7,32.29c-.05.4-.06.8-.14,1.2-.33,1.68-1.24,2.42-2.9,2.39-1.57-.03-2.44-.86-2.72-2.52-.17-1-.13-1.98.19-2.94.38-1.15,1.32-1.77,2.63-1.77,1.32,0,2.23.6,2.64,1.76.21.61.3,1.24.31,1.89"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.5,18.87c.18.53.27.9.43,1.24.32.64.04.74-.54.7-.39-.02-.59-.06-.4-.51.17-.4.3-.83.51-1.43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonEn);
export default __webpack_public_path__ + "static/media/amazon-en.217888e7aec586281ac8dc774ab881fa.svg";
export { ForwardRef as ReactComponent };